export const Domain = "pdviewa1.com.au";
export const DefaultPdClientType = "azure";
export const EnvironmentName = "Prod";
